import FormFreeSoloChipInput from "app/components/form-components/FormFreeSoloChipInput";

function Keywords(props) {
  return (
    <div>
      <FormFreeSoloChipInput {...props} />
    </div>
  );
}

export default Keywords;
